import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDatepickerInputEvent, MatDialog } from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { AddOfframpCryptoReceivedDialog } from './add-offramp-crypto-received/add-offramp-crypto-received.component';
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

// List of crypto auto-detected on TRON/SOLANA by
// offramp-automation.service.js - mirrors the CryptoReceived collection and
// stays read-only, except matchedTopupAmount/matchedStatus, which an admin
// can correct manually via the Edit action (auto-matching can miss/misfire).
@Component({
  selector: "app-offramp-crypto-received",
  templateUrl: "./offramp-crypto-received.component.html",
  styleUrls: ["./offramp-crypto-received.component.css"],
})
export class OfframpCryptoReceivedComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  networkOptions = ["TRC20", "SOLANA"];
  currencyOptions = ["USDT", "USDC"];

  filter: any = {
    page: 1,
    limit: 100,
    network: "",
    currency: "",
    search: "",
    fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;

  constructor(
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        sortable: false,
        filter: false,
        flex: 0.9,
        minWidth: 120,
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.justifyContent = 'flex-start';
          container.style.height = '100%';
          container.style.width = '100%';

          const viewBtn = document.createElement('button');
          viewBtn.type = 'button';
          viewBtn.className = 'btn btn-sm btn-info';
          viewBtn.title = 'View';
          viewBtn.style.display = 'flex';
          viewBtn.style.alignItems = 'center';
          viewBtn.style.justifyContent = 'center';
          viewBtn.style.padding = '4px 8px';
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, 'Offramp Crypto Received');
          };
          container.appendChild(viewBtn);

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-warning';
          editBtn.title = 'Edit Matched Topup';
          editBtn.style.display = 'flex';
          editBtn.style.alignItems = 'center';
          editBtn.style.justifyContent = 'center';
          editBtn.style.padding = '4px 8px';
          editBtn.style.marginLeft = '5px';
          editBtn.innerHTML = '<i class="fa fa-pencil"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          return container;
        }
      },
      {
        headerName: 'Tx Date',
        field: 'txDate',
        valueFormatter: (params) => params.value ? moment(params.value).format('MMM DD, YYYY hh:mm:ss A') : '',
        flex: 1.3
      },
      {
        headerName: 'User',
        field: 'userId',
        valueFormatter: (params) => {
          const user = params.value;
          if (!user) return '';
          return user.name ? `${user.name} (${user.email || ''})` : (user.email || '');
        },
        flex: 1.3
      },
      { headerName: 'Network', field: 'network', flex: 0.8 },
      { headerName: 'Currency', field: 'currency', flex: 0.8 },
      { headerName: 'Amount', field: 'amount', valueFormatter: (params) => this.formatNumber(params.value, 6), flex: 1 },
      {
        headerName: 'Matched Topup Amount',
        field: 'matchedTopupAmount',
        valueFormatter: (params) => this.formatNumber(params.value, 6),
        flex: 1.1
      },
      {
        headerName: 'Matched Status',
        field: 'matchedStatus',
        flex: 0.9,
        cellStyle: (params) => this.getStatusCellStyle(params.value),
      },
      { headerName: 'From Address', field: 'fromAddress', flex: 1.6 },
      { headerName: 'To Address', field: 'toAddress', flex: 1.6 },
      { headerName: 'Tx Hash', field: 'txHash', flex: 1.8 },
      {
        headerName: 'Recorded At',
        field: 'createdAt',
        valueFormatter: (params) => params.value ? moment(params.value).format('MMM DD, YYYY hh:mm:ss A') : '',
        flex: 1.3
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  private getStatusCellStyle(status: string) {
    if (status === 'PENDING') {
      return { background: '#ffe6e6' };
    }
    if (status === 'PARTIAL') {
      return { background: '#fff9c4' };
    }
    return null;
  }

  // Shows up to `decimals` places, dropping trailing zeros (400000 -> 4,00,000; 12.345678901 -> 12.345679).
  formatNumber(value: any, decimals: number = 2): string {
    if (value === null || value === undefined || isNaN(value)) return '';
    return Number(value).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals
    });
  }

  displayProperJson(jsonData, eventType) {
    let obj = {
      jsonData: jsonData,
      eventType: eventType || "Offramp Crypto Received"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddOfframpCryptoReceivedDialog, {
      width: '600px',
      maxWidth: '90vw',
      data: { record: record, _csrf: this._csrf },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.getData();
      }
    });
  }

  addRecord() {
    const dialogRef = this.dialog.open(AddOfframpCryptoReceivedDialog, {
      width: '600px',
      maxWidth: '90vw',
      data: { record: {}, _csrf: this._csrf },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.getData();
      }
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  clearSearch() {
    this.filter.search = '';
    this.getData();
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.offrampService.getAllOfframpCryptoReceived(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
      }

      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch offramp crypto received", defaults.notif);
    });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      network: "",
      currency: "",
      search: "",
      fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    this.getData();
  }

  exportArray() {
    this.spinnerService.show();

    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      network: this.filter.network,
      currency: this.filter.currency,
      search: this.filter.search,
      page: 1,
      limit: 10000
    };

    this.offrampService.getAllOfframpCryptoReceived(exportFilter).subscribe(
      (response: any) => {
        const list = (response && response.data) || [];
        if (list.length > 0) {
          const exportData = list.map((x: any) => ({
            'Tx Date': x.txDate ? moment(x.txDate).format('YYYY-MM-DD HH:mm:ss') : '',
            'User Name': x.userId && x.userId.name ? x.userId.name : '',
            'User Email': x.userId && x.userId.email ? x.userId.email : '',
            'Network': x.network,
            'Currency': x.currency,
            'Amount': x.amount,
            'From Address': x.fromAddress,
            'To Address': x.toAddress,
            'Tx Hash': x.txHash,
            'Matched Topup Amount': x.matchedTopupAmount,
            'Matched Status': x.matchedStatus,
            'Recorded At': x.createdAt ? moment(x.createdAt).format('YYYY-MM-DD HH:mm:ss') : '',
          }));
          TableUtil.exportArrayToExcel(exportData, 'OfframpCryptoReceived');
        } else {
          this.notifSer.info("Info", "No data available to export", defaults.notif);
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.notifSer.error("Error", "Failed to export data. Please try again.", defaults.notif);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-crypto-received/offramp-crypto-received.component.ts